import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { Input, Select } from "../../ui";
import { corporateDataCapture as v } from "./validate";
import { token } from "../../modules/auth";
import {
  fetchBookingDesks,
  fetchCompanyBranches,
  unloadAgencyBookingDesks,
  unloadCompanyBranches,
} from "../../redux/actions";

const mapStateToProps = state => {
  return {
    token: token(state),
    ...state.agencyBookingDesks,
  };
};

const mapDispatchToProps = {
  fetchBookingDesks,
  unloadAgencyBookingDesks,
};

const CompanyQuestions = ({
  company,
  token,
  isSuperAgent,
  agencyBookingDesks,
  unloadAgencyBookingDesks,
  fetchBookingDesks,
  change,
  form,
}) => {
  const [bookingDesk, setBookingDesk] = useState();
  useEffect(() => {
    if (company) {
      if (company.agency_id) {
        fetchBookingDesks(company.agency_id, token);
      }
    }
    if (!isSuperAgent) {
      change(form, "agency_booking_desk_id", company.default_booking_desk_id);
    }
    return () => {
      unloadAgencyBookingDesks();
    };
  }, [company]);

  const getAgencyBookingDeskOptions = () => {
    let options = [];
    if (agencyBookingDesks && agencyBookingDesks.length > 0) {
      agencyBookingDesks.map(desk => {
        if (isSuperAgent) {
          options.push({
            text: desk.name,
            value: desk.id,
          });
        } else {
          if (desk.id == company.default_booking_desk_id) {
            options.push({
              text: desk.name,
              value: desk.id,
            });
          }
        }
      });
    }
    if (agencyBookingDesks.length === 0 && company.default_booking_desk) {
      options.push({
        text: company.default_booking_desk.name,
        value: company.default_booking_desk.id,
      });
    }
    return options;
  };

  return (
    <div className="row mb-8 -mt-4">
      {!isSuperAgent ? null : !company.corporate_account_id ? (
        getAgencyBookingDeskOptions().length > 0 ? (
          <div className="col col-w-1/4">
            <Field
              name="agency_booking_desk_id"
              label="Booking Desk"
              component={Select}
              options={getAgencyBookingDeskOptions()}
              onChange={e => setBookingDesk(e.target.value)}
              wrapperClassName="inline mb-8 xl:w-1/2"
            />
          </div>
        ) : null
      ) : null}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyQuestions);
